import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import {
  useEnvironment,
  useExperiments,
  useModal,
  usePanorama,
} from '@wix/yoshi-flow-editor';
import { Button as ButtonLegacy } from '@wix/wix-ui-tpa';
import {
  Button as ButtonCssVars,
  ButtonPriority,
} from '@wix/wix-ui-tpa/cssVars';
import { classes } from './BuyNowButton.st.css';
import { classes as cssVarsClasses } from './BuyNowButton.cssVars.st.css';
import settingsParams from '../../../settingsParams';
import { useControllerProps } from '../../ControllerContext';
import { useState } from '../../stores';
import { PanoramaTransactions, SPECS } from '../../../../../consts';
import NoPremiumModal from '../../../modals/NoPremiumModal';
import { emailFieldRef } from '../ProductC2cForm/ProductC2cForm';

const BuyNowButton = () => {
  const {
    state: { checkout: checkoutState },
  } = useState();
  const settings = useSettings();
  const { isPreview } = useEnvironment();
  const { product, currencyCode } = useControllerProps().giftCardStore;
  const panorama = usePanorama();
  const { experiments } = useExperiments();
  const shouldShowNoPaymentMethodsModal = experiments.enabled(
    SPECS.AddNoPaymentMethodsModal,
  );
  const allowPreviewActions = experiments.enabled(SPECS.AllowPreviewActions);
  const isCssVars = experiments.enabled(
    SPECS.MigrateGiftCardWidgetToCssVars,
  );
  const Button = (
    isCssVars ? ButtonCssVars : ButtonLegacy
  ) as typeof ButtonCssVars;
  const buttonClassName = isCssVars ? cssVarsClasses.button : classes.button;

  const {
    createCheckout,
    reportCheckout,
    initShowNoPremiumModal,
    checkout,
    showNoPremiumModal,
    navigateToCheckout,
    creatingCheckout,
    addingToCart,
    purchase_options_validation,
  } = useControllerProps().giftCardCheckoutStore;
  const { openModal: openPreviewBlockingModal } = useModal(
    'PreviewBlockingModal',
    {
      width: 520,
      height: 270,
      theme: 'BARE',
    },
  );

  if (checkout) {
    checkout.id && navigateToCheckout(checkout.id);
  }

  const handleBuyNowButtonClick = async () => {
    if (isPreview && !allowPreviewActions) {
      openPreviewBlockingModal();
    } else if (product) {
      panorama.transaction(PanoramaTransactions.giftCardBuyNow).start();
      createCheckout(
        product.product_id,
        checkoutState.purchaseOptions,
        currencyCode || '',
      );
      if (!purchase_options_validation.recipientEmail) {
        emailFieldRef.current?.focus();
        return;
      }
      reportCheckout({
        product,
        purchase_options: checkoutState.purchaseOptions,
        currencyCode: currencyCode || '',
        type: 'buy now',
      });
      panorama.transaction(PanoramaTransactions.giftCardBuyNow).finish();
    }
  };

  return (
    <>
      <Button
        data-hook="rise-gift-card-buy-button"
        className={buttonClassName}
        fullWidth
        upgrade
        disabled={creatingCheckout || addingToCart}
        priority={ButtonPriority.primary}
        onClick={handleBuyNowButtonClick}
      >
        {settings.get(settingsParams.buyNowButtonText)}
      </Button>
      {shouldShowNoPaymentMethodsModal && (
        <NoPremiumModal
          isOpen={showNoPremiumModal}
          onModalClose={initShowNoPremiumModal}
        />
      )}
    </>
  );
};

export default BuyNowButton;
